// eslint-disable react/jsx-props-no-spreading -- Disabling as it's passed from the parent module.
import React from 'react';
import PropTypes from 'prop-types';
import { IntlProvider } from 'react-intl';
import { compose } from 'redux';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { addErrorToReport, loadLanguagePack } from '@americanexpress/one-app-ducks';
import TravelSearchDatePicker from './components/TravelSearchDatePicker';
import { MODULE_NAME } from './constants/moduleName';
import { mosaicContext } from './context/mosaicContext';

export const TravelSearchDatePickerWrapper = ({
  locale,
  languageData,
  isMosaicDesign,
  ...props
}) => {
  if (languageData) {
    return (
      <mosaicContext.Provider value={isMosaicDesign}>
        <IntlProvider locale={locale} messages={languageData}>
          {/* eslint-disable-next-line react/jsx-props-no-spreading -- spreading for wrapper */}
          <TravelSearchDatePicker {...props} />
        </IntlProvider>
      </mosaicContext.Provider>
    );
  }
  return null;
};
TravelSearchDatePickerWrapper.propTypes = {
  locale: PropTypes.string.isRequired,
  languageData: PropTypes.shape({}).isRequired,
  isMosaicDesign: PropTypes.bool,
};

export const loadModuleData = async ({ store: { dispatch } }) => {
  try {
    await Promise.all([
      dispatch(loadLanguagePack(MODULE_NAME, { fallbackLocale: 'en-US' })),
    ]);
  } catch (error) {
    dispatch(addErrorToReport(
      error,
      {
        collectionMethod: 'loadModuleData error',
        moduleId: 'axp-travel-search-date-picker',
        componentName: 'src/TravelSearchDatePickerWrapper',
      }
    ));
  }
};

TravelSearchDatePickerWrapper.holocron = {
  name: MODULE_NAME,
  loadModuleData,
};

const hocChain = compose(
  oneAppModuleWrapper(MODULE_NAME)
);

export default hocChain(TravelSearchDatePickerWrapper);
